import React from "react";
import PropTypes from "prop-types";

import { Control, Input, Label } from "rbx";

import { TariffSelect } from "../inputs";
import { OutsideTariffDateRangeDisplay } from "../../pages/DispatchProcessing/Orders/components";

import { useAuthorization } from "../Authorization";

import { useTariff } from "../../utils/hooks";

const TariffDisplay = ({
  tariffRecIdRef,
  readOnly = false,
  routeRecIdRef,
  deliveryDate,
  // endDate,
  onChange
}) => {
  const tariffRecId = parseInt(tariffRecIdRef);
  const { data: tariff } = useTariff(tariffRecId);
  const isAuthorized = useAuthorization(["ADMIN", "FIN"]);

  return (
    <div className="row tariff-info">
      <Control>
        <TariffSelect
          showHelp
          disabled={readOnly || !isAuthorized}
          icon="globe"
          label="Tariff"
          name="TariffRecIdRef"
          orderByMulti={["TariffCode_ASC"]}
          value={tariffRecId}
          where={{}}
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <Label>Description</Label>
        <Input readOnly value={tariff.Description} />
      </Control>
      <Control expanded>
        <Label>Tariff Type</Label>
        <Input readOnly value={tariff.TariffType?.CodeDescription} />
      </Control>
      <Control expanded>
        <Label>Fuel Surcharge Rate</Label>
        <Input
          readOnly
          value={tariff.FuelSurchargeRate ? `${tariff.FuelSurchargeRate}%` : ""}
        />
      </Control>
      <Control expanded>
        <OutsideTariffDateRangeDisplay
          dateFormat="MM/DD/YYYY"
          displayDate={tariff.BeginDate}
          label="Begin Date"
          name="BeginDate"
          routeRecId={routeRecIdRef}
          tariffRecId={tariffRecId}
          value={deliveryDate}
        />
      </Control>
      <Control expanded>
        <OutsideTariffDateRangeDisplay
          dateFormat="MM/DD/YYYY"
          displayDate={tariff.EndDate}
          label="End Date"
          name="EndDate"
          routeRecId={routeRecIdRef}
          tariffRecId={tariffRecId}
          value={deliveryDate}
        />
      </Control>
      <Control expanded>
        <Label>Min. Charge</Label>
        <Input
          readOnly
          value={tariff.MinCharge ? `$${tariff.MinCharge}` : ""}
        />
      </Control>
      <Control expanded>
        <Label>Min. Load</Label>
        <Input readOnly type="text" value={tariff.MinLoad} />
      </Control>
      <Control expanded>
        <Label>Max. Load</Label>
        <Input readOnly type="text" value={tariff.MaxLoad} />
      </Control>
    </div>
  );
};

TariffDisplay.propTypes = {
  tariffRecIdRef: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // endDate: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  routeRecIdRef: PropTypes.number,
  deliveryDate: PropTypes.string
};

export default TariffDisplay;
